import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Cup = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="M19.333 18.667H8.667c-.367 0-.667.3-.667.666 0 .367.3.667.667.667h10.666c.367 0 .667-.3.667-.667 0-.366-.3-.666-.667-.666zM7.333 8A3.337 3.337 0 004 11.333a3.337 3.337 0 003.333 3.334h.9A3.997 3.997 0 0012 17.333h4a4 4 0 004-4V8H7.333zM8 13.333h-.667c-1.102 0-2-.897-2-2 0-1.102.898-2 2-2H8v4z"
        id="prefix__a-cup"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="prefix__b-cup" fill="#fff">
        <use xlinkHref="#prefix__a-cup" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#prefix__a-cup" />
      <g mask="url(#prefix__b-cup)" fill={props.color || theme.palette.grey800}>
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);
